module.exports = __webpack_public_path__ + "494cd07c/img/lock-icon.bb9c7166.svg";